module.exports = __webpack_public_path__ + "img/9788957981757.beff75ea.jpg";